import React from 'react';
import { PropTypes } from 'prop-types';
import Menu from '../Menu';
import './styles.scss';

const Header = ({ bg, display = true }) => {
	return (
		<>
			{display && (
				<header id="myHeader" className={`header ${bg ? 'bg-red' : ''}`}>
					<Menu bg={bg} />
				</header>
			)}
		</>
	);
};

Header.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	bg: PropTypes.bool,
};

export default Header;
